import React from 'react';
import './message.css';
import rect from '../assets/animat/rect.png'
import Testimonial from '../CareTaker/Testimonial';

function Message() {
  const testinomialData = [
    {
      careTaker: 'Mir Sarfraz Ahmed Bugti',
      designation: 'Chief Minister of Balochistan',
      image: require('../assets/caretaker/MirSarfrazAhmedBugti.jpeg'),
      description: "The Balochistan Traffic Police's successful digitization of services marks progress not just for the province but for all of Pakistan. The partnership between Quetta Traffic Police and M/s Info Access Pakistan, backed by community trust and government support, underpins this achievement. Acknowledging their dedicated efforts, I extend congratulations and wish ongoing success to the Balochistan Police in serving our diverse nation.",
    },

    {
      careTaker: 'MUHAMMAD TAHIR (PSP)',
      designation: 'Inspector General of Police Balochistan',
      image: require('../assets/caretaker/mtahir.jpeg'),
      description: "Balochistan Traffic Police, a dedicated and professional force, upholds the highest standards of service to residents, businesses, and visitors. Their commitment to ethical conduct and community trust is unwavering. Despite the challenges of law enforcement, the commander takes pride in the force's adaptability and excellence. They also appreciate the contributions of M/s Info Access Pakistan in deploying the Traffic Management System.",
    },
    {

      careTaker: 'IMRAN SHAUKAT (PSP)',
      designation: 'Deputy Inspector General of Police Quetta',
      image: require('../assets/caretaker/public_Officerdig.jpeg'),
      description: "As Commissioner of Balochistan Traffic Police, the primary focus is on building public trust and enhancing safety. The goal is to provide efficient and respectful services while ensuring transparency in all interactions with the community. To address financial constraints, the department is undergoing a restructuring process to sustain the community's respect for the police force and to ensure exceptional service for future needs in Quetta.",
    },


  ];
  return (
    <div className="container cont-expMsg  msg-taker">
      <h1>Message By Caretaker</h1>
      <div className="rect-box3">
        <img src={rect} alt="" />
      </div>
      <div className="row pub-center ">
        {testinomialData.map((card, index) => (
          <div className="col-12 col-sm-6 col-lg-4 service-cards" data-aos="fade-up" key={card?.title || index}>
            <Testimonial link={card.link} msgCard={card} />
          </div>

        ))}
      </div>
    </div>
  );
}

export default Message;
